import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { CallCenterOrgSettings } from "./entity";

const createCustomFilter = createCustomFilterForEntity<CallCenterOrgSettings>();

export class CallCenterOrgSettingsFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<CallCenterOrgSettings>
  >((filters) => {
    return filterWithRelationsAndJson(CallCenterOrgSettings)(filters);
  });
}
